<template>
  <div class="crevent-coupon-page">
    <div v-if="loading" class="crevent-state">資料載入中...</div>
    <div v-if="!loading && !eventData" class="crevent-state">{{ emptyMessage }}</div>

    <div v-if="eventData" class="coupon_main">
      <div class="container">
        <div class="coupon_modal modal fade" ref="welcomeModal" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <h2>{{ eventData.PopupTitle || eventData.Name }}</h2>
                <div class="popup-content" v-html="eventData.PopupDescription"></div>
                <div class="btn_box">
                  <button class="btn_never" type="button" @click="neverShow">不再顯示</button>
                  <button class="btn_close" type="button" @click="closeModal">我已瞭解</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="carbonReduction_box">
          <div class="title_box">
            <img src="img/title_icon1.svg" alt="">
            <h2>{{ eventData.Name }}</h2>
          </div>
          <p class="time_box">賽季區間：<span>{{ eventPeriod }}</span></p>
          <div class="text_box">
            <div class="text">
              <p>賽季累積減碳量</p>
              <p><span>{{ formatCarbon(eventData.CarbonValueTotal) }}</span>kg</p>
            </div>
            <div class="text">
              <p>可兌換減碳量</p>
              <p><span>{{ formatCarbon(eventData.CarbonValueAvailable) }}</span>kg</p>
            </div>
          </div>
        </div>

        <div class="achievement_box">
          <div class="title_box">
            <img src="img/title_icon2.svg" alt="">
            <h2>賽季成就</h2>
          </div>
          <p class="total">{{ unlockedCount }}/{{ medals.length }}</p>
          <ul class="list">
            <li v-for="(item, index) in medals" :key="item.kilogram" :class="medalClass(index)">
              <div class="num"><img :src="item.src" alt=""></div>
              <p><span>{{ item.kilogram }}</span>kg</p>
            </li>
          </ul>
          <div class="text_box">
            <p><img src="img/trophy_icon.svg" alt="">{{ achievementText }}</p>
          </div>
        </div>

        <div class="redeem_box">
          <div class="title_box">
            <div><img src="img/title_icon3.svg" alt="">
              <h2>兌換商品</h2>
            </div>
            <button class="redeemed_btn" type="button" @click="gotoRedeemed">
              <img src="img/title_icon1.svg" alt="">
              <p>已兌換</p>
            </button>
          </div>
          <ul v-if="couponItems.length > 0 || storeItems.length > 0" class="tab_box">
            <li v-if="couponItems.length > 0"><button class="tab_btn" :class="{ active: activeTab === 0 }"
                @click="activeTab = 0">方案折抵券</button></li>
            <li v-if="storeItems.length > 0"><button class="tab_btn" :class="{ active: activeTab === 1 }"
                @click="activeTab = 1">合作店家</button></li>
          </ul>
          <div class="content">
            <ul class="coupon_list">
              <li v-for="item in currentItems" :key="item.CRIId" :class="{ redeemed: item.MaxQuantity <= 0 }">
                <a class="coupon_link" href="javascript:void(0)" @click="gotoItem(item)">
                  <div class="img_box"><img :src="itemImage(item.Image)" :alt="item.Name + '圖片'"></div>
                  <div class="title">
                    <h3>{{ item.Name }}</h3>
                    <p>{{ plainText(item.Description) }}</p>
                    <!-- <div v-if="item.MemberRedeemLimit > 0" class="member-redemption-limit">
                      <span>本活動兌換</span>
                      <span>已兌換 {{ item.MemberRedeemedQuantity || 0 }}份</span>
                      <span>上限 {{ item.MemberRedeemLimit }}份</span>
                    </div> -->
                    <!-- 修改span -->
                    <div v-if="item.MemberRedeemLimit > 0" class="member-redemption-limit">
                      <span>本活動已兌換</span>
                      <span>{{ item.MemberRedeemedQuantity || 0 }} 份</span>
                      <span>｜</span>
                      <span>每人兌換上限</span>
                      <span>{{ item.MemberRedeemLimit }} 份</span>
                    </div>
                  </div>
                  <div class="quantity_box">
                    <p class="quantity"><img src="img/leaf_w.svg" alt=""><span>{{ formatCarbon(item.CarbonAmount)
                    }}</span>kg</p>
                    <p>剩餘：{{ item.Inventory }}份</p>
                  </div>
                </a>
              </li>
            </ul>
            <p v-if="currentItems.length === 0" class="crevent-empty">目前沒有可兌換商品</p>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
/* global $, moment */
import Storage from '@/utils/storage.js'

export default {
  name: 'CREventCoupon',
  data() {
    return {
      loading: true,
      eventData: null,
      emptyMessage: '目前暫無進行中的減碳活動',
      activeTab: 0,
      medals: [
        { src: 'img/trophy_1.svg', kilogram: 5, badge: '新芽徽章 5kg' },
        { src: 'img/trophy_2.svg', kilogram: 30, badge: '青銅徽章 30kg' },
        { src: 'img/trophy_3.svg', kilogram: 100, badge: '白銀徽章 100kg' },
        { src: 'img/trophy_4.svg', kilogram: 150, badge: '黃金徽章 150kg' },
        { src: 'img/trophy_5.svg', kilogram: 500, badge: '永續徽章 500kg' }
      ]
    }
  },
  computed: {
    eventPeriod() {
      if (!this.eventData) return ''
      return moment(this.eventData.StartTime).format('YYYY-MM-DD') + ' ~ ' + moment(this.eventData.EndTime).format('YYYY-MM-DD')
    },
    currentItems() {
      if (!this.eventData) return []
      return this.activeTab === 0 ? this.couponItems : this.storeItems
    },
    couponItems() {
      if (!this.eventData) return []
      return this.eventData.Items.filter(item => item.ItemType !== 1 && item.ItemType !== 8)
    },
    storeItems() {
      if (!this.eventData) return []
      return this.eventData.Items.filter(item => item.ItemType === 1 || item.ItemType === 8)
    },
    unlockedCount() {
      if (!this.eventData) return 0
      return this.medals.filter(item => Number(this.eventData.CarbonValueTotal) >= item.kilogram).length
    },
    achievementText() {
      if (this.unlockedCount === 0) return '尚未解鎖成就'
      return '最新解鎖：' + this.medals[this.unlockedCount - 1].badge
    }
  },
  mounted() {
    $('.wrapper').addClass('crevent-coupon')
    $(window).scrollTop(0)
    this.loadData()
  },
  beforeDestroy() {
    if (this.$refs.welcomeModal) $(this.$refs.welcomeModal).modal('hide')
    document.body.classList.remove('welcome_modal')
  },
  methods: {
    loadData() {
      const that = this
      $.ajax({
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + '/Htmlv2/CREventCoupon',
        type: 'post',
        dataType: 'json',
        data: { token: Storage.get('ek_login_token') },
        complete: function () { that.loading = false },
        error: function () { that.showError('取得減碳活動資料失敗，請稍後再試一次') },
        success: function (res) {
          if (!res.ok) {
            if (res.noActiveEvent) that.emptyMessage = res.error
            else that.handleError(res)
            return
          }
          that.eventData = res.data
          that.activeTab = that.couponItems.length > 0 ? 0 : 1
          that.$nextTick(function () {
            if (!that.eventData.IsPopupHidden && that.eventData.PopupDescription) {
              document.body.classList.add('welcome_modal')
              $(that.$refs.welcomeModal).modal({ backdrop: 'static', keyboard: false, show: true })
              $(that.$refs.welcomeModal).on('hidden.bs.modal', function () {
                document.body.classList.remove('welcome_modal')
              })
            }
          })
        }
      })
    },
    closeModal() {
      $(this.$refs.welcomeModal).modal('hide')
    },
    neverShow() {
      const that = this
      $.ajax({
        url: that.GLOBAL.apiSrc + that.GLOBAL.subDirectory + '/Htmlv2/HideCREventPopup',
        type: 'post',
        dataType: 'json',
        data: { token: Storage.get('ek_login_token'), CREId: that.eventData.CREId },
        success: function (res) {
          if (!res.ok) return that.handleError(res)
          that.eventData.IsPopupHidden = true
          that.closeModal()
        },
        error: function () { that.showError('無法儲存提示設定，請稍後再試一次') }
      })
    },
    gotoItem(item) {
      if (item.MaxQuantity <= 0) return
      this.$router.push({ name: 'CREventCouponMain', params: { CREId: this.eventData.CREId, CRIId: item.CRIId } })
    },
    gotoRedeemed() {
      this.$router.push({ name: 'CREventRedeemedList', params: { CREId: this.eventData.CREId } })
    },
    medalClass(index) {
      if (index >= this.unlockedCount) return 'uncompleted'
      if (index === this.unlockedCount - 1) return 'current'
      return 'completed'
    },
    itemImage(image) {
      return image ? this.eventData.SiteUrl + image : 'img/coupon_logo.svg'
    },
    plainText(html) {
      const div = document.createElement('div')
      div.innerHTML = html || ''
      return (div.textContent || div.innerText || '').trim()
    },
    formatCarbon(value) {
      return Number(value || 0).toFixed(1)
    },
    handleError(res) {
      if (res && res.toekn_error) {
        Storage.remove('ek_login_token')
        this.$router.push({ name: 'Login' })
        return
      }
      this.showError((res && res.error) || '操作失敗')
    },
    showError(message) {
      this.$swal({ heightAuto: false, title: '錯誤', text: message, icon: 'error', confirmButtonText: '確定' })
    }
  }
}
</script>

<style scoped>
.crevent-coupon-page .coupon_link .title {
  flex: 1;
  min-width: 0;
  overflow-wrap: anywhere;
}

.crevent-coupon-page .coupon_link .quantity_box {
  flex-shrink: 0;
}

.member-redemption-limit {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  margin-top: 10px;
  background: #f0f6f1;
  color: #2d7a47;
  font-size: 0.8rem;
  line-height: 1.6;
}

.member-redemption-limit span {
  max-width: 100%;
}

.coupon_main .redeem_box .coupon_list li .coupon_link {
  flex-direction: row;
  position: relative;
  padding: 0;
}

.coupon_main .redeem_box .coupon_list li .coupon_link .img_box {
  border-radius: 20px 0 0 20px;
}

.coupon_main .redeem_box .coupon_list li .coupon_link .title {
  padding: 15px 0;
  padding-left: 10px;
  padding-bottom: 10px;
}

.coupon_main .redeem_box .coupon_list li .coupon_link .quantity_box {
  padding: 5px 10px;
  padding-top: 10px;
  align-items: flex-end;
  flex-basis: 0px;
}

.coupon_link .member-redemption-limit {
  gap: 4px 4px;
  position: absolute;
  bottom: -23px;
  right: 0;
  border: 1px solid #2d7a47;
  border-radius: 12px;
  padding: 3px 12px;
  padding-top: 5px;
}

.coupon_main .redeem_box .coupon_list li {
  padding-bottom: 21px;
}

@media (min-width: 576px) {
  .coupon_link .member-redemption-limit {
    bottom: -15px;
  }

  .coupon_main .redeem_box .coupon_list li .coupon_link .quantity_box {
    flex-basis: 90px;
    padding: 10px;
    padding-top: 15px;
    padding-left: 0px;
  }

}

.member-redemption-limit {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/CREventCoupon.vue